module.exports = __webpack_public_path__ + "static/top_about_bg-6e062bb8330cd475ee2b32f11251f413.jpg";